import { Avatar, Button, CircularProgress, Card, CardContent, Chip, Divider, Fab, Tab, Tabs, Grid, Tooltip, Typography, TextField, Select, MenuItem, InputAdornment, IconButton, Stack, Modal, Table, TableHead, TableRow, TableCell, TableBody, Paper, FormControl, InputLabel, } from "@mui/material";
import searchIcon from "../../icons/searchIcon.svg"
import ThreeSixtyIcon from "@mui/icons-material/ThreeSixty";
import React, { useState, useEffect, useContext } from "react";
import clearFilterImage from "../../../src/icons/clearFilter.svg";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import * as XLSX from "xlsx";
import styled from "styled-components";
import Box from "@mui/material/Box";
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import { DataGrid, GridToolbarContainer, GridToolbarColumnsButton, GridToolbarFilterButton, GridToolbarDensitySelector, GridToolbarExport, GridDensitySelector, getGridStringOperators, } from "@mui/x-data-grid";
import { TABS, ROLES, DATE_FORMATS } from "../../constants";
import { Add, AddAPhoto, AddTask, SaveAlt, SaveAltOutlined, SaveAs, ManageSearch, Send, Search } from "@mui/icons-material";
import OpaqueLoading from "../../components/opaqueLoading/opaqueLoading";
import "../../App.css";
import { height } from "@mui/system";
import closeIcon from "../../icons/CloseIcon.svg"
import SwapConverIcon from "../../icons/sendEmail.svg"
import { set } from "date-fns";
const isMobile = window.innerWidth < 900;
const StaffEditorPageContainer = styled.div`
  height: ${isMobile ? `auto` : `calc(100vh - 105px)`};
  width: 100%;
  background-color: white;
  padding: 10px 15px;
  ${isMobile &&
    `
      position: relative;
      `}
`;
const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 7px;
`;
const TableContainer = styled.div`
  //   height: calc(
  //     100vh - ${isMobile
        ? "56px - 20px - 82.23px"
        : "128px - 29px - 50.77px"}
  //   );
  width: 100%;
  border: solid 1px lightGrey;
  border-radius: 8px;
`;
const DataGridContainer = styled.div`
  max-width: 100%; /* Add this line to limit the width */
  margin: 0 auto; /* Center the content horizontally */
  height: 100%;
  width: 100%;
  //   border: solid 1px lightGrey;
  display: ${isMobile ? "flex" : "grid"};
  border-radius: 4px;
  ${isMobile &&
    `
    flex-direction: column;
  `}
`;
const TabsContainer = styled.div`
  ${isMobile &&
    `
    height: calc(100vh - 56px - 20px - 43.77px);
  `}
`;
const AutomationLogs = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [paginationModel, setPaginationModel] = useState({ page: currentPage - 1, pageSize: 20, });
    const [rowCount, setRowCount] = useState();
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [rsms, setRsms] = useState([]);
    const [allUsers, setAllUsers] = useState([]);
    const [asms, setAsms] = useState([]);
    const [rms, setRms] = useState([]);
    const [rm, setRm] = useState("")
    const [rsm, setRsm] = useState("")
    const [asm, setAsm] = useState("")
    const [visibleEmployees, setVisibleEmployees] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pageSize, setPageSize] = useState(20)
    const [accessModulesData, setAccessModulesData] = useState([]);
    const [userData, setUserData] = useState(JSON.parse(localStorage.getItem('storedUserData')).user)
    const [newOrderStatus, setNewOrderStatus] = useState("");
    const [automationStatus, setAutomationStatus] = useState("")
    const [filteredDate, setFilteredData] = useState({});
    const [modalData, setModalData] = useState([])
    const [openViewModal, setOpenViewModal] = useState(false)

    useEffect(() => {
        fetchSessions();
    }, []);

    const fetchSessions = async () => {
        try {
            setLoading(true);
            const response = await window.Platform.database.getAllSessions();
            // if (response?.data) {
            //   setSessions(response.data);
            // }
            if (response?.status) {
                const filterdData1 = response?.data?.filter((ele, ind) => ele?.action == "active")
                setFilteredData(filterdData1[0])
            }
            else {
                window.NotificationUtils.showError("Something Went Wrong in session")
            }
        } catch (error) {
            console.error("Error fetching sessions:", error);
            window.NotificationUtils.showError("Failed to load sessions");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchEmployees();
    }, [paginationModel.page, paginationModel.pageSize, newOrderStatus]);


    useEffect(() => {
        fetchAccessModules();
        if (userData?.role.toLowerCase().includes('admin')) {
            getAllUsers()
        }
        if (userData?.role == 'rsm') {
            getUsers('rsm', userData?.id)
        }
        if (userData?.role == 'asm') {
            getUsers('asm', userData?.id)
        }
    }, [])

    async function getAllUsers() {
        let results = await window.Platform.database.fetchEmployees()
        if (results?.status) {
            window.NotificationUtils.showError(results.message);
            setLoading(false);
            return;
        }
        else {
            setAllUsers(results?.data)
            setRsms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'rsm'))
            setRms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'se'))
            setAsms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'asm'))
            setLoading(false);
        }
    }

    async function getUsers(role, id) {
        if (id != "") {
            let results = await window.Platform.database.getUsersBasedOnManager({ userId: id })
            if (role == 'rsm') {
                setAsms(results?.data)
                setRms(results?.data1)
            }
            if (role == 'asm') {
                setRms(results?.data)
            }
        } else {
            if (role == 'rsm') {
                setRm("")
                setAsm("")
                setRms(allUsers?.filter((ele) => ele.role == 'se'))
                setAsms(allUsers?.filter((ele) => ele.role == 'asm'))
            }
            if (role == 'asm') {
                setRm("")
                setRms(allUsers?.filter((ele) => ele.role == 'se'))
            }
        }

    }

    const fetchAccessModules = async () => {
        try {
            setLoading(true);
            let data = {
                pageNumber: paginationModel.page,
                recordPerPage: paginationModel.pageSize,
                userId: userData?.id,
                moduleId: "2mcEyrlAXR"
            }
            let results = await window.Platform.database.fetchAccessModules(data);
            if (results?.status) {
                window.NotificationUtils.showError(results?.message || "Something went wrong");
                setLoading(false);
                return;
            }
            else {
                const jsonArrayWithId = results?.data?.map((obj, index) => ({ ...obj, idIndex: index + 1 }));
                setAccessModulesData(jsonArrayWithId);
            }
        } catch (error) {
            console.error(error);
        }
        finally {
            setLoading(false)
        }
    }

    const formatDate1 = (dateStr) => {
        if (!dateStr) return "N/A";

        const date = new Date(dateStr);

        if (isNaN(date)) return "N/A";

        return date.toLocaleString("en-IN", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: true
        });
    };

    const handleOpenViewModal = (id) => {
        console.log(id, "isdsdsdsd")
        setModalData(id)
        setOpenViewModal(true);
    }

    const handleCloseViewModal = () => {
        setOpenViewModal(false);
        setModalData([]);
    }

    const getAllAddOns = (seriesObj) => {
        let addOns = Array.isArray(seriesObj?.add_ons)
            ? [...seriesObj.add_ons]
            : [];

        Object.keys(seriesObj || {}).forEach(key => {
            if (
                !["series_id", "subjects", "add_ons"].includes(key) &&
                typeof seriesObj[key] === "number"
            ) {
                addOns.push(`${key} (${seriesObj[key]})`);
            }
        });

        return addOns;
    };

    const groupedBySeries = {};

    modalData?.content_assignment?.forEach(cls => {
        cls.series?.forEach(ser => {
            const seriesKey = ser.series_id || "N/A";

            if (!groupedBySeries[seriesKey]) {
                groupedBySeries[seriesKey] = [];
            }

            groupedBySeries[seriesKey].push({
                class_name: cls.class_name,
                subjects: ser.subjects || [],
                add_ons: getAllAddOns(ser) // ✅ FIXED
            });
        });
    });

    const handleDownloadExcel = () => {
        try {
            if (!modalData) {
                window.NotificationUtils.showError("No data available to download.");
                return;
            }

            const classOrderMap = {
                "NURSERY": 1,
                "LKG": 2,
                "L K G": 2,
                "UKG": 3,
                "CLASS 1": 4,
                "CLASS 2": 5,
                "CLASS 3": 6,
                "CLASS 4": 7,
                "CLASS 5": 8,
                "CLASS 6": 9,
                "CLASS 7": 10,
                "CLASS 8": 11,
                "CLASS 9": 12,
                "CLASS 10": 13,
                "CLASS 11": 14,
                "CLASS 12": 15
            };

            // ✅ Normalize class names
            const normalizeClass = (name) =>
                (name || "")
                    .toUpperCase()
                    .replace(/[^A-Z0-9 ]/g, "")
                    .replace(/\s+/g, " ")
                    .trim();

            const rows = [];

            const address = [modalData?.AddressLine1, modalData?.AddressLine2]
                .filter(Boolean)
                .join(" ") || "N/A";

            // ================= BUILD ROWS =================
            if (groupedBySeries && Object.keys(groupedBySeries).length > 0) {

                Object.entries(groupedBySeries).forEach(([seriesName, classes]) => {
                    classes.forEach((cls) => {
                        rows.push({
                            "SO ID": modalData?.soid || "N/A",
                            "School ID": modalData?.school_id || "N/A",
                            "School Name": modalData?.school_name || "N/A",
                            "Address 1": modalData?.AddressLine1 || "N/A",
                            "Address 2": modalData?.AddressLine2 || "N/A",
                            "District": modalData?.District || "N/A",
                            "State": modalData?.State || "N/A",
                            "Pincode": modalData?.Pincode || "N/A",
                            "Board": modalData?.school_board || "N/A",
                            "Medium": modalData?.school_medium || "N/A",
                            "Grade": modalData?.grade || "N/A",
                            "Strength": modalData?.strength || "N/A",
                            "Website": modalData?.website || "N/A",
                            "Decision Maker": modalData?.decision_maker || "N/A",
                            "Decision Maker Mobile": modalData?.decision_maker_mobile_no || "N/A",
                            "Distributor ID": modalData?.distributor_id || "N/A",
                            "Distributor Name": modalData?.distributor_name || "N/A",
                            "Distributor Address 1": modalData?.distributor_address_1 || "N/A",
                            "Distributor Address 2": modalData?.distributor_address_2 || "N/A",
                            "RM Name": modalData?.rm_name || "N/A",
                            "RM Email": modalData?.rm_email || "N/A",
                            "RM Mobile": modalData?.rm_mobile || "N/A",
                            "Employee ID": modalData?.rm_employee_id || "N/A",
                            "Series Name": seriesName || "N/A",
                            "Class Name": cls?.class_name || "N/A",
                            "Subjects": (cls?.subjects || []).join(", ") || "N/A",
                            "Add-ons": cls?.add_ons?.length ? cls.add_ons.join(", ") : "N/A",
                            "LMS Status": modalData?.is_success?.toLowerCase() === "success" ? "Success" : "Failure",
                            "Created At": formatDate1(modalData?.created_at) || "N/A",

                        });
                    });
                });

            } else {
                // fallback
                rows.push({
                    "SO ID": modalData?.soid || "N/A",
                    "School ID": modalData?.school_id || "N/A",
                    "School Name": modalData?.school_name || "N/A",
                    "Address 1": modalData?.AddressLine1 || "N/A",
                    "Address 2": modalData?.AddressLine2 || "N/A",
                    "District": modalData?.District || "N/A",
                    "State": modalData?.State || "N/A",
                    "Pincode": modalData?.Pincode || "N/A",
                    "Board": modalData?.school_board || "N/A",
                    "Medium": modalData?.school_medium || "N/A",
                    "Grade": modalData?.grade || "N/A",
                    "Strength": modalData?.strength || "N/A",
                    "Website": modalData?.website || "N/A",
                    "Decision Maker": modalData?.decision_maker || "N/A",
                    "Decision Maker Mobile": modalData?.decision_maker_mobile_no || "N/A",
                    "Distributor ID": modalData?.distributor_id || "N/A",
                    "Distributor Name": modalData?.distributor_name || "N/A",
                    "Distributor Address 1": modalData?.distributor_address_1 || "N/A",
                    "Distributor Address 2": modalData?.distributor_address_2 || "N/A",
                    "RM Name": modalData?.rm_name || "N/A",
                    "RM Email": modalData?.rm_email || "N/A",
                    "RM Mobile": modalData?.rm_mobile || "N/A",
                    "Employee ID": modalData?.rm_employee_id || "N/A",
                    "Series Name": "N/A",
                    "Class Name": "N/A",
                    "Subjects": "N/A",
                    "Add-ons": "N/A",
                    "LMS Status": modalData?.is_success?.toLowerCase() === "success" ? "Success" : "Failure",
                    "Created At": formatDate1(modalData?.created_at) || "N/A",
                });
            }

            // ================= FINAL SORT (FIXED) =================
            rows.sort((a, b) => {
                // 1️⃣ Sort by Series Name
                if (a["Series Name"] !== b["Series Name"]) {
                    return (a["Series Name"] || "").localeCompare(b["Series Name"] || "");
                }

                // 2️⃣ Then sort by Class Order
                const orderA = classOrderMap[normalizeClass(a["Class Name"])] || 999;
                const orderB = classOrderMap[normalizeClass(b["Class Name"])] || 999;

                return orderA - orderB;
            });

            // ================= CREATE EXCEL =================
            const workbook = XLSX.utils.book_new();
            const worksheet = XLSX.utils.json_to_sheet(rows);

            XLSX.utils.book_append_sheet(workbook, worksheet, "Automation Logs");

            const fileName = `AutomationLogs_${modalData?.rm_employee_id || "Report"}.xlsx`;
            XLSX.writeFile(workbook, fileName);

        } catch (error) {
            console.error("Excel Download Error:", error);
            window.NotificationUtils.showError("Failed to download Excel file.");
        }
    };

    const schoolColumns = () => {
        const stringOperators = getGridStringOperators().filter((op) =>
            ["contains"].includes(op.value)
        );

        let result = [
            {
                field: "empId1",
                headerName: "Emp ID",
                width: 100,
                filterable: false,
                sortable: false,
                valueGetter: (params) => {
                    let name = params.row.rm_employee_id || "N/A"
                    return name;
                },
                renderCell: (params) => {
                    let name = params.row.rm_employee_id || "N/A";
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
                        </Tooltip>
                    );
                },
            },
            {
                field: "name11",
                headerName: "Employee Name",
                width: 200,
                filterable: false,
                sortable: false,
                valueGetter: (params) => {
                    let name = params.row.rm_name || "N/A"
                    return name;
                },
                renderCell: (params) => {
                    let name = params.row.rm_name || "N/A";
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name}</Typography>
                        </Tooltip>
                    );
                },
            },
            {
                field: "createdAt1",
                headerName: "Created At",
                minWidth: 180,
                sortable: false,
                filterable: false,
                renderCell: (params) => {
                    return (
                        <Tooltip title={params.row.created_at || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}> {formatDate1(params.row.created_at) || "N/A"} </Typography>
                        </Tooltip>
                    );
                },
            },
            {
                field: "schoolId1",
                headerName: "School ID",
                width: 150,
                filterable: false,
                sortable: false,
                valueGetter: (params) => {
                    let name = params.row.school_id || "N/A"
                    return name;
                },
                renderCell: (params) => {
                    let name = params.row.school_id || "N/A";
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name}</Typography>
                        </Tooltip>
                    );
                },
            },
            {
                field: "soId1",
                headerName: "SO ID",
                width: 200,
                filterable: false,
                sortable: false,
                valueGetter: (params) => {
                    let name = params.row.soid || "N/A"
                    return name;
                },
                renderCell: (params) => {
                    let name = params.row.soid || "N/A";
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name}</Typography>
                        </Tooltip>
                    );
                },
            },

            {
                field: "View",
                headerName: "View",
                minWidth: 140,
                sortable: false,
                renderCell: (params) => {
                    return (
                        <>
                            <Tooltip>
                                <span>
                                    <Button
                                        variant="contained"
                                        size="small"
                                        onClick={() => handleOpenViewModal(params.row)}
                                        sx={{ minWidth: "80px" }}
                                    >
                                        {"View"}
                                    </Button>
                                </span>
                            </Tooltip>
                            <Modal open={openViewModal} onClose={handleCloseViewModal}>
                                <Box
                                    sx={{
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        width: "80%",
                                        bgcolor: "white",
                                        boxShadow: 24,
                                        p: 4,
                                        borderRadius: 2,
                                        maxHeight: "90%",
                                        overflowY: "auto",
                                        position: "relative", // ✅ important
                                    }}
                                >
                                    <Box sx={{ position: "absolute", top: 10, right: 10, cursor: "pointer", }} onClick={handleCloseViewModal} >
                                        <img src={closeIcon} height={30} width={30}></img>
                                    </Box>
                                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
                                        <Typography variant="h6" component="h2">
                                            Automation Logs Details
                                        </Typography>
                                        {accessModulesData && accessModulesData[0]?.is_download?.toLowerCase() != "no" &&
                                            <Button sx={{ mr: 5 }} color="success" variant="contained" onClick={handleDownloadExcel} >
                                                Download Excel
                                            </Button>}
                                    </Box>
                                    <Grid container spacing={2}>
                                        <Box
                                            sx={{
                                                display: "inline-block", px: 2, py: 1, ml: 3, borderRadius: "8px", boxShadow: 3,
                                                backgroundColor:
                                                    modalData?.is_success?.toLowerCase() === "success"
                                                        ? "#e8f5e9"
                                                        : "#ffebee",
                                                color:
                                                    modalData?.is_success?.toLowerCase() === "success"
                                                        ? "#2e7d32"
                                                        : "#c62828",
                                                fontWeight: 600,
                                                fontSize: "14px"
                                            }}
                                        >
                                            LMS Status:{" "}
                                            {modalData?.is_success?.toLowerCase() === "success"
                                                ? "Success"
                                                : "Failure"}
                                        </Box>
                                        <Grid item xs={12}>
                                            <Card sx={{ borderRadius: 2, boxShadow: 3 }}>
                                                <CardContent>
                                                    <Typography variant="h6" gutterBottom>User Details</Typography>
                                                    <Divider sx={{ mb: 2 }} />

                                                    <Grid container spacing={2}>
                                                        <Grid item xs={6}><b>User Name:</b> {modalData?.rm_name || "N/A"}</Grid>
                                                        <Grid item xs={6}><b>Emp ID:</b> {modalData?.rm_employee_id || "N/A"}</Grid>
                                                        <Grid item xs={6}><b>Email:</b> {modalData?.rm_email || "N/A"}</Grid>
                                                        <Grid item xs={6}><b>Mobile:</b> {modalData?.rm_mobile || "N/A"}</Grid>
                                                    </Grid>
                                                </CardContent>
                                            </Card>
                                        </Grid>

                                        {/* ✅ SCHOOL DETAILS */}
                                        <Grid item xs={12}>
                                            <Card sx={{ borderRadius: 2, boxShadow: 3 }}>
                                                <CardContent>
                                                    <Typography variant="h6" gutterBottom>School Details</Typography>
                                                    <Divider sx={{ mb: 2 }} />

                                                    <Grid container spacing={2}>
                                                        <Grid item xs={6}><b>School Name:</b> {modalData?.school_name || "N/A"}</Grid>
                                                        <Grid item xs={6}><b>School ID:</b> {modalData?.school_id || "N/A"}</Grid>
                                                        <Grid item xs={6}><b>Board:</b> {modalData?.school_board || "N/A"}</Grid>
                                                        <Grid item xs={6}><b>Medium:</b> {modalData?.school_medium || "N/A"}</Grid>
                                                        <Grid item xs={6}><b>Grade:</b> {modalData?.grade || "N/A"}</Grid>
                                                        <Grid item xs={6}><b>Strength:</b> {modalData?.strength || "N/A"}</Grid>
                                                    </Grid>
                                                </CardContent>
                                            </Card>
                                        </Grid>

                                        {/* ✅ ADDRESS */}
                                        <Grid item xs={12}>
                                            <Card sx={{ borderRadius: 2, boxShadow: 3 }}>
                                                <CardContent>
                                                    <Typography variant="h6" gutterBottom>Address</Typography>
                                                    <Divider sx={{ mb: 2 }} />

                                                    <Grid container spacing={2}>
                                                        <Grid item xs={12}>
                                                            <b>Address:</b> {[modalData?.AddressLine1, modalData?.AddressLine2].filter(Boolean).join(" ") || "N/A"}
                                                        </Grid>
                                                        <Grid item xs={6}><b>District:</b> {modalData?.District || "N/A"}</Grid>
                                                        <Grid item xs={6}><b>State:</b> {modalData?.State || "N/A"}</Grid>
                                                        <Grid item xs={6}><b>Pincode:</b> {modalData?.Pincode || "N/A"}</Grid>
                                                    </Grid>
                                                </CardContent>
                                            </Card>
                                        </Grid>

                                        {/* 🔥 CONTENT ASSIGNMENT (BEST UI) */}
                                        <Grid item xs={12}>
                                            <Typography variant="h6" gutterBottom>Content Assignment</Typography>

                                            <Grid container spacing={2}>
                                                {Object.keys(groupedBySeries).length > 0 ? (
                                                    Object.entries(groupedBySeries).map(([seriesName, classes], index) => (

                                                        <Grid item xs={12} md={6} key={index}>
                                                            <Card
                                                                sx={{
                                                                    borderRadius: 3,
                                                                    boxShadow: 4,
                                                                    borderLeft: "5px solid #1976d2",
                                                                }}
                                                            >
                                                                <CardContent>

                                                                    {/* ✅ SERIES TITLE */}
                                                                    <Typography variant="h6" sx={{ mb: 1 }}>
                                                                        {seriesName.toUpperCase()}
                                                                    </Typography>

                                                                    <Divider sx={{ mb: 2 }} />

                                                                    {/* ✅ CLASS + SUBJECTS */}
                                                                    {classes.map((cls, i) => (
                                                                        <div key={i} style={{ marginBottom: "12px" }}>

                                                                            <Typography variant="subtitle1">
                                                                                <b>Class:</b> {cls.class_name}
                                                                            </Typography>

                                                                            {/* Subjects as Chips */}
                                                                            <div style={{ marginTop: "5px" }}>
                                                                                {cls.subjects?.length > 0 ? (
                                                                                    cls.subjects.map((sub, idx) => (
                                                                                        <Chip
                                                                                            key={idx}
                                                                                            label={sub}
                                                                                            size="small"
                                                                                            sx={{ mr: 1, mb: 1 }}
                                                                                        />
                                                                                    ))
                                                                                ) : (
                                                                                    <span>N/A</span>
                                                                                )}
                                                                            </div>

                                                                            {/* Add-ons */}
                                                                            {cls.add_ons?.length > 0 && (
                                                                                <Typography variant="body2">
                                                                                    <b>Add-ons:</b> {cls.add_ons.length > 0 ? cls.add_ons.join(", ") : "N/A"}
                                                                                </Typography>
                                                                            )}

                                                                        </div>
                                                                    ))}

                                                                </CardContent>
                                                            </Card>
                                                        </Grid>

                                                    ))
                                                ) : (
                                                    <Typography>N/A</Typography>
                                                )}
                                            </Grid>
                                        </Grid>

                                    </Grid>
                                    <Box mt={2} display="flex" justifyContent="flex-end">
                                        <Button onClick={handleCloseViewModal} variant="contained" color="primary">
                                            Close
                                        </Button>
                                    </Box>
                                </Box>
                            </Modal>
                        </>
                    );
                },
            },
            // {
            //     field: "converToOrder",
            //     headerName: "Send Email",
            //     width: 150,
            //     sortable: false,
            //     renderCell: (params) => {
            //         return (
            //             <>
            //                 <Tooltip>
            //                     <span>
            //                         <Button 
            //                         startIcon={<img src={SwapConverIcon} alt="icon" height={"21"} width={"21"} />} 
            //                         variant="contained" size="small" 
            //                         // onClick={() => handleConvertToOrder(params.row)} 
            //                         sx={{ minWidth: "90px", fontSize: "12px", fontWeight: "500" }} 
            //                         >
            //                             Send
            //                         </Button>
                                    
            //                        </span>
            //                 </Tooltip>
            //             </>
            //         );
            //     },
            // },
        ].filter(Boolean);
        return result;
    };

    const exportAutomationLogsExcel = async () => {
        setLoading(true);
        try {
            let data = {
                rsm: userData?.role == 'rsm' ? userData?.id : rsm,
                asm: userData?.role == 'asm' ? userData?.id : asm,
                ownerId: rm,
                startDate: startDate != '' ? startDate : filteredDate?.startDate,
                endDate: endDate != '' ? endDate : filteredDate?.endDate,
                is_success: automationStatus
            }
            let result = await window.Platform.database.exportData("order/downloadAutomationLogsExcel",
                data
            )
            const blob = new Blob([result.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const now = new Date();
            const formattedDate = `${now.getDate().toString().padStart(2, '0')}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getFullYear()}`;
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `AutomationLogs_Report_${formattedDate}.xlsx`);
            // link.setAttribute("download", "attendance.xlsx");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.error("Export error:", error);
        }
    }

    const fetchEmployees = async () => {
        setLoading(true);
        try {
            setVisibleEmployees([]);

            let results = await window.Platform.database.getAutomationLogs({
                rsm: userData?.role == 'rsm' ? userData?.id : rsm,
                asm: userData?.role == 'asm' ? userData?.id : asm,
                ownerId: rm,
                pageNumber: paginationModel.page,
                recordPerPage: paginationModel.pageSize,
                startDate: startDate != '' ? startDate : filteredDate?.startDate,
                endDate: endDate != '' ? endDate : filteredDate?.endDate,
                is_success: automationStatus
            });
            setRowCount(results?.total)

            const jsonArrayWithId = results?.data?.map((obj, index) => ({
                ...obj,
                id: index + 1,
            }));
            setVisibleEmployees(jsonArrayWithId);
            if (results.success) {
                setLoading(false);
            } else {
                setLoading(false);
                window.NotificationUtils.showError(results.message);
            }
        } catch (error) {
            console.error(error);
            setLoading(false);
        }
    };

    const clearFilter = async () => {
        setLoading(true);
        setRsm("");
        setAsm("");
        setRm("");
        setStartDate("")
        setEndDate("")
        setAutomationStatus("")
        setRsms(allUsers?.filter((ele) => ele.role.toLowerCase() === 'rsm'));
        setRms(allUsers?.filter((ele) => ele.role.toLowerCase() === 'se'));
        setAsms(allUsers?.filter((ele) => ele.role.toLowerCase() === 'asm'));
        setVisibleEmployees([]);
        setRowCount(0);

        setLoading(false);
    };

    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <GridToolbarColumnsButton />
                <GridToolbarFilterButton />
                <GridToolbarExport
                    csvOptions={{
                        fileName: "users-report",
                    }}
                />
            </GridToolbarContainer>
        );
    }
    const renderTabContent = () => {
        return (<>
            <div className="d-flex  align-items-center  py-2">
                <Typography variant="body1" ml={3} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>Select Page Size:&nbsp; </Typography>
                <Select
                    value={paginationModel.pageSize}
                    variant="outlined"
                    size="small"
                    onChange={(e) => { setPaginationModel({ ...paginationModel, pageSize: e.target.value }) }}
                    sx={{ width: 90, fontSize: 13, fontWeight: "500" }}
                >
                    {[10, 20, 30, 50, 100].map((role) => (
                        <MenuItem key={role} value={role} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{role}</MenuItem>
                    ))}
                </Select>
            </div>
            <DataGridContainer
                style={{ height: !visibleEmployees.length ? "200px" : "auto" }}
            >
                <DataGrid
                    className="payrollGrid"
                    density="compact"
                    rows={visibleEmployees || []}
                    columns={schoolColumns()}
                    sx={{ color: "black", fontSize: "14px", fontWeight: "600" }}

                    disableSelectionOnClick
                    disableRowSelectionOnClick
                    rowHeight={60}
                    rowCount={rowCount}
                    paginationModel={paginationModel}
                    paginationMode="server"
                    onPaginationModelChange={setPaginationModel}
                />
            </DataGridContainer>
        </>
        );
    };

    return (
        <>
            <StaffEditorPageContainer>
                <HeaderContainer>
                    <Box sx={{ mt: 1, width: "100%" }}>
                        <Paper elevation={3}
                            sx={{
                                p: 2,
                                mb: 2,
                                width: '100%',        // takes full width of parent
                                // maxWidth: '1000px',   // optional: control max width
                                mx: 'auto',
                                backgroundColor: "#ebf0fa"          // center it horizontally
                            }}>
                            <div className="container-fluid" style={{ width: "100%" }}>
                                <div className="row">
                                    {userData?.role.includes('admin') && <div className="col-md-3">
                                        <FormControl fullWidth size="small">
                                            <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select HO</InputLabel>
                                            <Select
                                                value={rsm}
                                                label="Select HO"
                                                size="small"
                                                onChange={(e) => { setRsm(e.target.value); getUsers('rsm', e.target.value); setAsm(""); setRm("") }}
                                            >
                                                <MenuItem value="" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>All</MenuItem>
                                                {rsms.map((role) => (
                                                    <MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{role.name} - {role.username}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </div>}
                                    {userData?.role != 'asm' && <div className="col-md-3">
                                        <FormControl size="small" fullWidth>
                                            <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select ARM</InputLabel>
                                            <Select
                                                value={asm}
                                                label="Select ARM"
                                                size="small"
                                                onChange={(e) => { setAsm(e.target.value); getUsers('asm', e.target.value); setRm(""); }}
                                            >
                                                <MenuItem value="" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>All</MenuItem>
                                                {asms.map((role) => (
                                                    <MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{role.name} - {role.username}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </div>}
                                    <div className="col-md-3">
                                        <FormControl size="small" fullWidth>
                                            <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select RM:</InputLabel>
                                            <Select
                                                value={rm}
                                                label="Select RM"
                                                size="small"
                                                onChange={(e) => { setRm(e.target.value) }}
                                            >
                                                <MenuItem value="" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>All</MenuItem>
                                                {rms.map((role) => (
                                                    <MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{role.name} - {role.username}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </div>
                                    {accessModulesData && accessModulesData[0]?.is_download?.toLowerCase() != "no" && <div className="col-md-3">
                                        <Button variant="contained" color="success" startIcon={<FileDownloadIcon />} fullWidth sx={{ borderRadius: "10px" }} onClick={() => { exportAutomationLogsExcel() }}>Download</Button>
                                    </div>}
                                </div>
                                <div className="row mt-2">
                                    <div className="col-md-3">
                                        <FormControl fullWidth size="small">
                                            <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select Status</InputLabel>
                                            <Select label="Select Status" value={automationStatus} size="small" onChange={(e) => { setAutomationStatus(e.target.value); }} sx={{ width: '100%', fontSize: 14 }}>
                                                <MenuItem value="" sx={{ color: "black", fontSize: "14px", fontWeight: "400" }} >All</MenuItem>
                                                <MenuItem key={2} value={"success"} sx={{ color: "black", fontSize: "14px", fontWeight: "400" }}>Success</MenuItem>
                                                <MenuItem key={1} value={"failed"} sx={{ color: "black", fontSize: "14px", fontWeight: "400" }}>Failure</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div className="col-md-2">
                                        <FormControl fullWidth size="small">
                                            <TextField label="From Date" size="small" type="date" sx={{ color: "black", fontSize: "13px", fontWeight: 500 }} className="form-control" value={startDate} onChange={(e) => setStartDate(e.target.value)}
                                                InputLabelProps={{
                                                    shrink: true,
                                                    style: { color: "black", fontSize: "13px", fontWeight: 500 }
                                                }}
                                                inputProps={{
                                                    style: { color: "black", fontSize: "13px", fontWeight: 500 }
                                                }} />
                                        </FormControl>
                                    </div>
                                    <div className="col-md-2">
                                        <FormControl fullWidth size="small">
                                            <TextField label="To Date" size="small" type="date" sx={{ color: "black", fontSize: "13px", fontWeight: 500 }} className="form-control" value={endDate} onChange={(e) => setEndDate(e.target.value)}
                                                InputLabelProps={{
                                                    shrink: true,
                                                    style: { color: "black", fontSize: "13px", fontWeight: 500 }
                                                }}
                                                inputProps={{
                                                    style: { color: "black", fontSize: "13px", fontWeight: 500 }
                                                }} />
                                        </FormControl>
                                    </div>
                                    <div className="col-md-2">
                                        <Button variant="contained" size="small" startIcon={<img src={searchIcon} alt="icon" height={"21"} width={"21"} />} color="primary" fullWidth sx={{ fontSize: '14px', borderRadius: '10px' }} onClick={() => fetchEmployees()}>
                                            Find
                                        </Button>
                                    </div>
                                    <div className="col-md-3">
                                        <Button variant="contained" startIcon={<img src={clearFilterImage} alt="icon" height={"21"} width={"21"} />} color="secondary" size="small" fullWidth sx={{ fontSize: '14px', borderRadius: '10px' }} onClick={() => clearFilter()}>
                                            Clear Filters
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </Paper>
                    </Box>
                </HeaderContainer>
                <TableContainer>
                    <TabsContainer>
                        {loading && <OpaqueLoading />}
                        {renderTabContent()}
                    </TabsContainer>
                </TableContainer>
            </StaffEditorPageContainer>
        </>
    );
};

export default AutomationLogs;
